import type { InternalAxiosRequestConfig } from 'axios';
import { toast } from 'sonner';

import { usePreviewStore } from '@/stores/previewStore';

const SAFE_METHODS = new Set(['get', 'head', 'options']);

// Writes a previewing trainer must still be able to perform (session management).
const PREVIEW_WRITE_ALLOWLIST = ['/api/v1/auth/logout', '/api/v1/auth/refresh'];

export class PreviewBlockedError extends Error {
  isPreviewBlocked = true;

  constructor(url: string) {
    super(`Blocked in student preview: ${url}`);
    this.name = 'PreviewBlockedError';
  }
}

// Safety net behind the per-component disabling: while "preview as student" is
// active, no write request may leave the app, even from a surface we forgot.
export function previewRequestGuard(config: InternalAxiosRequestConfig): InternalAxiosRequestConfig {
  if (!usePreviewStore.getState().active) return config;

  const method = (config.method ?? 'get').toLowerCase();
  if (SAFE_METHODS.has(method)) return config;

  const url = config.url ?? '';
  if (PREVIEW_WRITE_ALLOWLIST.some((p) => url.includes(p))) return config;

  toast.error('Not available in student preview', { id: 'preview-block' });
  throw new PreviewBlockedError(url);
}
